// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"327":"515feb0b","611":"de8fb54e","915":"bb1d4d30"}[chunkId] + ".chunk.js";
};